import { ReactElement, lazy } from 'react';
import { generateRouteElements } from '@app/routes/generateRouteElements';
import { EAppRoutes } from '@common/enums';
import { IRouteItem } from '@common/interfaces';

const BulkGeoAreaContainerLazy = lazy(
  () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkGeoAreaContainer')
);

const BulkPointOfInterestContainerLazy = lazy(
  () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkPointOfInterestContainer')
);

const BulkVideoPlacementContainerLazy = lazy(
  () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkVideoPlacementContainer')
);

const BulkBannerPlacementContainerLazy = lazy(
  () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkBannerPlacementContainer')
);

const BulkTimePartingContainerLazy = lazy(
  () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkTimePartingContainer')
);

// TODO: need to be fix with BE-A2, it should be changed props for endpoint
// const BulkSourceSupplyContainerLazy = lazy(
//   () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkSourceSupplyContainer')
// );
//
// const BulkVerifiedSupplyContainerLazy = lazy(
//   () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkVerifiedSupplyContainer')
// );

const BulkAppSiteListContainerLazy = lazy(
  () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkAppSiteListContainer')
);

const BulkDealsContainerLazy = lazy(
  () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkDealsContainer')
);

const BulkDevicesContainerLazy = lazy(
  () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkDevicesContainer')
);

const BulkBrowserContainerLazy = lazy(
  () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkBrowserContainer')
);

const BulkOperatingSystemContainerLazy = lazy(
  () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkOperatingSystemContainer')
);

const BulkCarrierContainerLazy = lazy(
  () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkCarrierContainer')
);

const BulkFreqCapContainerLazy = lazy(
  () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkFreqCapContainer')
);

const BulkCreativeDisplayContainerLazy = lazy(
  () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkCreativeDisplayContainer')
);

const BulkCreativeVideoContainer = lazy(
  () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkCreativeVideoContainer')
);

const BulkCreativeNativeContainerLazy = lazy(
  () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkCreativeNativeContainer')
);

const BulkCreativeAudioContainerLazy = lazy(
  () => import('@features/bulk-edit/components/Optimization/Targeting/categories/BulkCreativeAudioContainer')
);

const routeItems: IRouteItem[] = [
  { path: EAppRoutes.TargetingGeo, component: <BulkGeoAreaContainerLazy /> },
  { path: EAppRoutes.TargetingLocationPOI, component: <BulkPointOfInterestContainerLazy /> },
  { path: EAppRoutes.TargetingVideoPlacement, component: <BulkVideoPlacementContainerLazy /> },
  { path: EAppRoutes.TargetingBannerPlacement, component: <BulkBannerPlacementContainerLazy /> },
  { path: EAppRoutes.TargetingDayParting, component: <BulkTimePartingContainerLazy /> },
  // TODO: need to be fix with BE-A2, it should be changed props for endpoint
  // { path: EAppRoutes.TargetingSupplySource, component: <BulkSourceSupplyContainerLazy /> },
  // { path: EAppRoutes.TargetingVerifiedSource, component: <BulkVerifiedSupplyContainerLazy /> },
  { path: EAppRoutes.TargetingSiteAndApp, component: <BulkAppSiteListContainerLazy /> },
  { path: EAppRoutes.TargetingInventoryDeals, component: <BulkDealsContainerLazy /> },
  { path: EAppRoutes.TargetingDeviceType, component: <BulkDevicesContainerLazy /> },
  { path: EAppRoutes.TargetingInventoryBrowser, component: <BulkBrowserContainerLazy /> },
  { path: EAppRoutes.TargetingOs, component: <BulkOperatingSystemContainerLazy /> },
  { path: EAppRoutes.TargetingCarrier, component: <BulkCarrierContainerLazy /> },
  { path: EAppRoutes.TargetingFrequency, component: <BulkFreqCapContainerLazy /> },

  { path: EAppRoutes.TargetingCreativeBanner, component: <BulkCreativeDisplayContainerLazy /> },
  { path: EAppRoutes.TargetingCreativeVideo, component: <BulkCreativeVideoContainer /> },
  { path: EAppRoutes.TargetingCreativeNative, component: <BulkCreativeNativeContainerLazy /> },
  { path: EAppRoutes.TargetingCreativeAudio, component: <BulkCreativeAudioContainerLazy /> },
];

export const bulkDealRoutes: ReactElement[] = generateRouteElements(routeItems);
